import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { SingleTariff } from './SingleTariff';
import { MultiTariff } from './MultiTariff';

export function TariffActivation() {
  // Contexts
  const { bookableTariffs } = useActivation();

  // REMOVE: console.log
  // console.log('TariffActivation', bookableTariffs);
  return (
    <>
      {bookableTariffs.length === 1 && <SingleTariff />}
      {bookableTariffs.length > 1 && <MultiTariff />}
    </>
  );
}

export default TariffActivation;
